import Image from 'next/image';

export default function NotFound() {
  return (
    <div className='align-items-center d-flex flex-column justify-content-center mt-5 pt-5'>
      <h1 className='text-center'>
        404 <br /> Page Not Found
      </h1>
      <Image
        src={'/images/fancy/not-found.svg'}
        alt='Not Found'
        width={300}
        height={200}
      />
    </div>
  );
}
